import React, { Component, PropTypes } from 'react';
import getTopOffset from '../../../utils/getOffsetTop';
import css from './content.scss';
import translate from '../../../utils/translate';

import CornerLabel from '../../block/cornerLabel';
import Pixeltext from '../../svg/pixeltext';
import Image from '../../image/image';
import QAContent from './qa';

import { PlayerWithTrigger } from './../../video/player';

import {
	EDITORIAL_TYPE_QA,
	EDITORIAL_TYPE_ARTICLE,
	EDITORIAL_SIDEBAR_TYPE_IMAGE,
	EDITORIAL_SIDEBAR_TYPE_YOUTUBE,
	EDITORIAL_SIDEBAR_TYPE_VIMEO,
	EDITORIAL_SIDEBAR_TYPE_LINK,
} from '../../../constants/types';

export default class EditorialContent extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		editorial: PropTypes.object.isRequired,
	};

	static defaultProps = {
		editorial: {},
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.scrollHandler = this.scrollHandler.bind(this);

		this.state = {
			placeholderHeight: 0,
			placeholderWidth: 0,
			posToStick: -1,
			posToStickEndStick: -1,
			isSticky: false,
			posToLinkStick: -1,
			isLinkSticky: false,
		};
	}

	componentDidMount() {
		this.props.browser.scroll.register(this.scrollHandler);
		this.updateDimensions();
	}

	componentDidUpdate() {}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.scrollHandler);
		this.mounted = false;
		clearTimeout(this.t);
	}

	componentWillReceiveProps(nextProps) {
		if (
			this.props.browser.window.width !== nextProps.browser.window.width ||
			this.props.editorial.id !== nextProps.editorial.id
		) {

			if (this.props.editorial.id !== nextProps.editorial.id) {
				this.resetSticky();
			}

			this.updateDimensions();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.editorial.id !== prevProps.editorial.id) {
			clearTimeout(this.t);

			this.resetSticky();
			this.t = setTimeout(() => {
				this.updateDimensions();
			}, 100);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.editorial.id !== this.props.editorial.id ||
			this.state !== nextState
		);
	}

	resetSticky() {
		if (this.state.posToStick === -1) {
			return;
		}

		this.setState({
			...this.state,
			placeholderHeight: 0,
			placeholderWidth: 0,
			posToStick: -1,
			posToStickEndStick: -1,
			isSticky: false,
			posToLinkStick: -1,
			isLinkSticky: false,
		});
	}

	updateDimensions() {
		const images = window.document.getElementsByTagName('img');
		for (let i = 0; i < images.length; i++) {
			if (!images[i].complete) {
				this.resetSticky();
				setTimeout(() => {
					this.updateDimensions();
				}, 25);

				return false;
			}
		}

		if (!this.mounted) {
			return false;
		}

		const newState = { ...this.state };

		if (this.refs.stickyWrapper && this.refs.stickyPrimary) {
			const stWrapper = this.refs.stickyWrapper;
			const stPrimary = this.refs.stickyPrimary;
			const stPlaceholder = this.refs.stickyPlaceholder;

			newState.posToStick = getTopOffset(stPlaceholder);
			newState.posToStickEndStick = newState.posToStick + stWrapper.clientHeight;
			newState.placeholderHeight = stPrimary.clientHeight;
			newState.placeholderWidth = stPrimary.clientWidth;
		}

		if (this.refs.stickyLinks) {
			newState.posToLinkStick = getTopOffset(this.refs.stickyLinks);
		}

		this.mounted && this.setState(newState);

		return true;
	}

	scrollHandler(e) {
		let scrollY = e.scrollY + (this.props.browser.window.width > 719 ? 61 : 50); // account for top-nav

		if (
			this.state.posToStick === -1
		) {
			return;
		}

		// if (scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick) {
		// 	console.log(this.refs.stickyWrapper.getAttribute('data-reactid').substr(-1, 2));
		// }
		let isSticky = (scrollY > this.state.posToStick);
		let isMobile = this.props.browser.window.width <= 719;
		let isLinkSticky = (scrollY > this.state.posToLinkStick && !isMobile);
		if ((isSticky !== this.state.isSticky || isLinkSticky !== this.state.isLinkSticky) && this.mounted) {
			this.setState({
				...this.state,
				isSticky,
				isLinkSticky,
			});
		}
	}

	render() {
		let { contents, sections, layoutType } = this.props.editorial;

		let phStyle = {};
		phStyle.height = ((this.state.placeholderHeight > 0) ? this.state.placeholderHeight : 1) + 'px';

		if (!this.state.placeholderHeight) {
			setTimeout(() => {
				this.updateDimensions();
			}, 500);
		}

		return (
			<div className='editorial-content editorial-content__sticky-wrapper' ref='stickyWrapper'>
				<div className='span2 hide-mobile cf'>
					<div ref='stickyPlaceholder' className='sticky-placeholder' style={phStyle}></div>
					{this.getLabelArea(layoutType)}
				</div>
				<div className='span12 span14-mobile editorial-content__container'>
					<div className='span8 span14-mobile editorial-content__content'>
						{this.getContent(contents)}
					</div>
					<div className='span14-mobile span4 editorial-content__aside'>
						{this.getAside(sections)}
					</div>
					<div className='span8 span14-mobile editorial-content__content'>
						<div className='editorial-content__splitter pixel-pattern span8 span14-mobile'></div>
						<section className='editorial-content__section editorial-content__section__answer'>
							<div className='span5 span7-tablet span12-mobile'>{translate('editorials/editorialsCopyright')}</div>
							<div className='cf'></div>
						</section>
					</div>
				</div>
			</div>
		);
	}

	getContent(contents) {
		return contents.map((content, i) => {
			return this.getMainContent(content, i);
		});
	}

	getLabelArea(type) {
		switch (type) {
			case EDITORIAL_TYPE_QA:
				let qStyle = {
					width: 'inherit',
				};
				if (this.state.isSticky) {
					qStyle.top = (this.props.browser.window.width > 719 ? 61 : 50) + 'px';
					qStyle.position = 'fixed';
				} else {
					qStyle.position = 'absolute';
					qStyle.top = '0px';
				}

				return (
					<div ref='stickyPrimary' className='editorial-content__stickprimary'>
						<div className="editorial-content__qa-block"></div>
						<div style={qStyle}>
							<div className='pixel-pattern editorial-content__qa-block'>
								<Pixeltext text='Q' textAnchor='right' x='100%' y='0px' className='editorial-content__qa-svg' />
							</div>
							<div className='pixel-pattern editorial-content__qa-block'>
								<Pixeltext text='A' textAnchor='right' x='100%' y='0px' className='editorial-content__qa-svg' />
							</div>
						</div>
					</div>
				);
			default:
				return '\u00a0';
		}
	}

	getMainContent(content, id) {
		switch (content.type.toUpperCase()) {
			case 'EDITORIAL-QA':
				return this.getQA(content, id);
			default:
				return this.getArticle(content, id);
		}
	}

	getArticle(content, id) {
		if (content && (content.text === '<p></p>' || !content.text)) {
			return false;
		}

		return (
			<section className='editorial-content__section' key={'art' + id}>
				<div className='span5 span7-tablet span12-mobile' dangerouslySetInnerHTML={{ __html: content.text }}></div>
				<div className='cf'></div>
			</section>
		);
	}

	getQA(content, id) {
		if (content && (content.answer === '<p></p>' || content.question === '<p></p>')) {
			return false;
		}

		return (
			<QAContent content={content} key={id} browser={this.props.browser} />
		);
	}

	getAside(contents) {
		return (
			<div className='editorial-content__aside-block'>
				{this.getAsideContent(contents)}
				{this.getAsideLinks(contents)}
			</div>
		);
	}

	getAsideContent(contents) {
		return (<div>
			{contents.map((content, i) => {
				switch (content.type) {
					case EDITORIAL_SIDEBAR_TYPE_IMAGE:
						return this.getAsideImage(content, i);
					case EDITORIAL_SIDEBAR_TYPE_YOUTUBE:
						return this.renderVideo(i, content.youtube, content.description);
					case EDITORIAL_SIDEBAR_TYPE_VIMEO:
						return this.renderVideo(i, content.vimeo, content.description);
				}
			})}
		</div>);
	}

	renderVideo(key, video, description) {
		let className = 'editorial-content__aside-block__video';

		if (description) {
			className += ' editorial-content__aside-block__video--wdesc';
		}

		return (
			<div key={key} className="hide-mobile">
				<PlayerWithTrigger browser={this.props.browser} key={key} url={video} className={className} />
				<p>
					{description}
				</p>
			</div>
		);
	}

	getAsideLinks(contents) {
		if ((function() {
			for (var i = 0; i < contents.length; i++) {
				if (contents[i].type === EDITORIAL_SIDEBAR_TYPE_LINK) {
					return false;
				}
			}

			return true;
		})()) {
			// if no links found
			return false;
		}

		let className = 'span14-mobile span4 editorial-content__aside__links';
		if (this.state.isLinkSticky) {
			className += ' editorial-content__aside__links--sticky';
		}

		return (
			<div>
				<hr />
				<div className={className} ref='stickyLinks'>
					<CornerLabel name='Links' />

					{contents.map((content, i) => {
						switch (content.type) {
							case EDITORIAL_SIDEBAR_TYPE_LINK:
								return this.getAsideLink(content, i);
						}
					})}
				</div>
			</div>

		);
	}

	getAsideImage(content, i) {
		if (!content.image) {
			return false;
		}

		if (content.description !== '') {
			return (
				<div key={i} className="hide-mobile">
					<Image img={content.image} alt={content.image_alt} span='span4' browser={this.props.browser} className='editorial-content__aside-block__img editorial-content__aside-block__img--wdesc' />
					<p>{content.description}</p>
				</div>
			);
		} else {
			return (
				<Image key={i} img={content.image} alt={content.image_alt} span='span4' browser={this.props.browser} className='editorial-content__aside-block__img hide-mobile' />
			);
		}
	}

	getAsideLink(content, i) {
		if (!content.link_name && !content.link) {
			return false;
		}

		return (
			<div key={i}>
				<a  className='button button--go' href={content.link} title={content.link_title} target='_blank'>{content.link_name}</a>
			</div>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./frontend/components/editorial/content/content.js
 **/